import { Icon, kuiperClassNames } from '@opallabs/kuiper'
import { StampManagerActions } from './StampManagerActions'

export const getColumns = (
  getCellContents,
  onSetName,
  onDeleteStamp,
  onViewStamp
) => {
  const columns = [
    {
      title: 'Name',
      type: 'text',
      visible: true,
      editable: true,
      toggleable: false,
      getMaxLength: ({ entityType }) =>
        entityType === 'post' ? 100 : undefined,
      getCellContents: ({ entityId }) => getCellContents(entityId, 'name'),
      getLeftSlot: ({ entityType }) => {
        const glyph = entityType === 'moment' ? 'moment' : 'content'
        return (
          <div className={kuiperClassNames('icon-wrapper')}>
            <Icon glyph={glyph} height={14} width={14} ariaMode="hidden" />
          </div>
        )
      },
      onBlur: onSetName,
    },
    {
      title: 'Limited To',
      type: 'text',
      visible: true,
      editable: false,
      toggleable: false,
      getCellContents: ({ entityId }) =>
        getCellContents(entityId, 'is_limited'),
    },
    {
      title: 'Permissions',
      type: 'text',
      visible: true,
      editable: false,
      toggleable: false,
      getCellContents: ({ entityId }) =>
        getCellContents(entityId, 'permission_mode'),
    },
    {
      title: 'Created By',
      type: 'text',
      visible: true,
      editable: false,
      toggleable: false,
      getCellContents: ({ entityId }) => getCellContents(entityId, 'user'),
    },
    {
      title: 'Created On',
      type: 'text',
      visible: true,
      editable: false,
      toggleable: false,
      getCellContents: ({ entityId }) =>
        getCellContents(entityId, 'created_at'),
    },
    {
      title: 'Actions',
      type: 'component',
      visible: true,
      editable: false,
      toggleable: false,
      getCellContents: ({ entityId }) =>
        StampManagerActions({ entityId, onDeleteStamp, onViewStamp }),
    },
  ]

  return columns
}
